/**
 * Navigation — mobiles Menue und Zustand der Kopfzeile.
 * Ohne Abhaengigkeiten. Ohne JavaScript bleibt die Seite bedienbar:
 * die Fusszeile enthaelt alle Links.
 */
(function () {
  "use strict";

  var schalter = document.getElementById("menue-schalter");
  var menue = document.getElementById("mobilmenue");
  var kopf = document.getElementById("kopfzeile");

  /* --- Mobiles Menue ----------------------------------------------------- */

  if (schalter && menue) {
    var istOffen = false;

    var oeffnen = function () {
      istOffen = true;
      menue.hidden = false;
      // Erst im naechsten Frame die Klasse setzen, sonst laeuft die
      // Transition nicht — das Element war bis eben display:none.
      requestAnimationFrame(function () {
        menue.classList.add("ist-offen");
      });
      schalter.setAttribute("aria-expanded", "true");
      schalter.querySelector(".nur-sr").textContent = "Menü schließen";
      document.body.classList.add("menue-offen");
    };

    var schliessen = function (fokusZurueck) {
      istOffen = false;
      menue.classList.remove("ist-offen");
      schalter.setAttribute("aria-expanded", "false");
      schalter.querySelector(".nur-sr").textContent = "Menü öffnen";
      document.body.classList.remove("menue-offen");

      // hidden erst setzen, wenn die Ausblendung durchgelaufen ist.
      window.setTimeout(function () {
        if (!istOffen) menue.hidden = true;
      }, 260);

      if (fokusZurueck) schalter.focus();
    };

    schalter.addEventListener("click", function () {
      if (istOffen) schliessen(false);
      else oeffnen();
    });

    // Escape schliesst und gibt den Fokus zurueck.
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && istOffen) schliessen(true);
    });

    // Klick auf einen Menuepunkt schliesst ebenfalls.
    menue.addEventListener("click", function (e) {
      if (e.target.closest("a")) schliessen(false);
    });

    // Beim Wechsel auf Desktopbreite aufraeumen.
    var breit = window.matchMedia("(min-width: 861px)");
    var beiWechsel = function (e) {
      if (e.matches && istOffen) schliessen(false);
    };
    if (breit.addEventListener) breit.addEventListener("change", beiWechsel);
    else if (breit.addListener) breit.addListener(beiWechsel);
  }

  /* --- Kopfzeile: Trennlinie erst nach dem Scrollen ----------------------- */

  if (kopf) {
    var gescrollt = false;

    var pruefen = function () {
      var soll = window.scrollY > 8;
      if (soll !== gescrollt) {
        gescrollt = soll;
        kopf.classList.toggle("ist-gescrollt", soll);
      }
    };

    pruefen();
    window.addEventListener("scroll", pruefen, { passive: true });
  }
})();
